export default __webpack_public_path__ + "static/media/rabbit5.2101f635.gif";